import { EditDataConnectionsAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/EditDataConnectionAction';
import { IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IExplorableItemTypeInfo } from '~src/spacesPlatform/models/resourceInfoParts';

import { editFlowAnalyticsExtensionConnection } from '../actions/EditFlowAnalyticsExtensionConnectionAction';
import { isFlowAnalyticsExtensionRow } from '../models/FlowAnalyticsExtensionRow';

export const EditFlowConnectionsAction: typeof EditDataConnectionsAction = {
  ...EditDataConnectionsAction,
  isClickable: (availableActions, content, state) => {
    const extension = content.find(isFlowAnalyticsExtensionRow);
    return extension
      ? content.length === 1 && !!extension.analyticsExtensionFlowLuid && extension.analyticsExtensionConnection.canUpdate
      : EditDataConnectionsAction.isClickable(availableActions, content, state);
  },
  createReduxAction: content => content.some(isFlowAnalyticsExtensionRow)
    ? editFlowAnalyticsExtensionConnection(content)
    : EditDataConnectionsAction.createReduxAction(content),
};

export function getFlowConnectionEntityAction(
  action: IEntityAction<IExplorableItemTypeInfo, any>,
  items: IExplorableItemTypeInfo[],
): IEntityAction<IExplorableItemTypeInfo, any> {
  return action.name === EditDataConnectionsAction.name && items.some(isFlowAnalyticsExtensionRow)
    ? EditFlowConnectionsAction
    : action;
}
